import { useField } from 'formik'
import Select from './Select'

const FormikSelect = ({ label, required, options, placeholder, ...props }) => {
  const [field, meta] = useField(props)

  return (
    <Select
      {...field}
      {...props}
      label={label}
      required={required}
      options={options}
      placeholder={placeholder}
      error={meta.touched && meta.error ? meta.error : undefined}
    />
  )
}

export default FormikSelect

